export default {
    zqPayOrder: {
        showObj: {
            show1: 'Settlement No.:',
            show2: 'Confirm Payment Amount:',
            show3: 'Settlement Amount:',
            show4: 'This is the principal amount of the current settlement, which includes the total order amount within this billing cycle. The total amount for billed items is',
            show5: 'Overdue Penalty:',
            show6: 'Overdue penalty rate per day:',
            show7: 'Amount Due:',
            show8: 'Amount Due = Settlement Amount',
            show9: 'Amount Due = Settlement Amount + Overdue Penalty',
            show10: 'Overdue by 3 days',
        }
    }
}